import {
  rawMaterialPayload,
  packageMaterial,
  transformedData,
} from '../CreateProductFlowInterfaces';
import { RawMaterialProps } from 'enums/RawMaterialEnums';
import { Supplier } from 'models/Supplier/Supplier.model';
import { CategoryOptions } from '../CreateProductFlowInterfaces';
import { TransportationProps } from 'enums/TransportationEnums';
import { MultipleOriginsProductRawMaterial } from 'models/MultipleOriginsProductRawMaterial/multipleOriginsProductRawMaterial.model';

export const transformPayload = (data: rawMaterialPayload) => {
  const transformedPayload: MultipleOriginsProductRawMaterial[] = [];
  const payload: rawMaterialPayload = Object.create(data)

  payload.ingredients.forEach(ingredient => {
    if (!ingredient.origins?.length) return
    let originTotal = 0
    let totalQuantity = Number(ingredient.ingredientQuantity);
    ingredient.origins.forEach(origin => {
      const originQuantity = (Number(ingredient.ingredientQuantity) * Number(origin.originShare)) / 100;
      origin.quantity = (originQuantity).toFixed(2);
      originTotal += Number((originQuantity).toFixed(2));
    });
    if (totalQuantity !== originTotal) {
      let differenceAmount = Number((totalQuantity - originTotal))
      if (ingredient.origins[0]?.quantity !== undefined) {
        ingredient.origins[0].quantity = (+(ingredient.origins[0].quantity) + differenceAmount).toString()
      }
    }
  });

  payload.packageMaterials.forEach(packaging => {
    if (!packaging.origins?.length) return
    let originTotal = 0
    let totalQuantity = Number(packaging.packingMaterialQuantity);
    packaging.origins.forEach(origin => {
      const originQuantity = (Number(packaging.packingMaterialQuantity) * Number(origin.originShare)) / 100;
      origin.quantity = originQuantity.toFixed(2);
      originTotal += Number((originQuantity).toFixed(2));
    });
    if (totalQuantity !== originTotal) {
      let differenceAmount = Number((totalQuantity - originTotal))
      if (packaging.origins[0]?.quantity !== undefined) {
        packaging.origins[0].quantity = (+(packaging.origins[0].quantity) + differenceAmount).toString()
      }
    }
  })

  payload.ingredients.forEach(ingredient => {
    if (ingredient.origins?.length) {
      ingredient.origins.forEach(origin => {
        transformedPayload.push({
          id: origin.id,
          type: RawMaterialProps.INGREDIENT,
          unit: ingredient.ingredientUnit,
          quantity: origin.quantity,
          co2e: 0,
          origin: origin.ingredientOrigin,
          address: origin.address,
          activityMappingRegionSpecId:
            typeof origin?.bestfitRegion === 'object'
              ? origin.bestfitRegion.value
              : Number(origin.bestfitRegion),
          originShare: origin.originShare,
        });
      });
    } else {
      transformedPayload.push({
        id: ingredient.id,
        type: RawMaterialProps.INGREDIENT,
        unit: ingredient.ingredientUnit,
        quantity: ingredient.ingredientQuantity,
        co2e: 0,
        origin: ingredient.ingredientOrigin,
        address: ingredient.address,
        activityMappingRegionSpecId: ingredient.bestFitProductionRegion.value
          ? ingredient.bestFitProductionRegion.value
          : ingredient.bestFitProductionRegion,
        originShare: 0,
      });
    }
  });
  payload.packageMaterials.forEach((packageMaterial: packageMaterial) => {
    if (packageMaterial.origins?.length) {
      packageMaterial.origins.forEach(origin => {
        transformedPayload.push({
          id: origin.id,
          type: RawMaterialProps.PACKAGING,
          quantity: origin.quantity,
          unit: packageMaterial.packingMaterialUnit,
          co2e: 0,
          origin: origin.ingredientOrigin,
          unitsPerPackagingMaterial: Number(
            packageMaterial.numberOfUnitsPerPackingMaterial
          ),
          address: origin?.address,
          activityMappingRegionSpecId:
            typeof origin?.bestfitRegion === 'object'
              ? origin.bestfitRegion.value
              : Number(origin.bestfitRegion),
          originShare: origin.originShare,
        });
      });
    } else {
      transformedPayload.push({
        id: packageMaterial.id,
        type: RawMaterialProps.PACKAGING,
        quantity: packageMaterial.packingMaterialQuantity,
        unit: packageMaterial.packingMaterialUnit,
        co2e: 0,
        origin: packageMaterial.packingMaterialOrigin,
        unitsPerPackagingMaterial: Number(
          packageMaterial.numberOfUnitsPerPackingMaterial
        ),
        address: packageMaterial?.address,
        activityMappingRegionSpecId: packageMaterial
          .packingMaterialbestFitProductionRegion.value
          ? packageMaterial.packingMaterialbestFitProductionRegion.value
          : packageMaterial.packingMaterialbestFitProductionRegion,
        originShare: 0,
      });
    }
  });
  console.log("transformedPayload ", transformedPayload)
  return transformedPayload;
};

export const convertToOptions = (data: Supplier[]) => {
  const options: CategoryOptions[] = [];
  data.map((item: Supplier) => {
    options.push({
      label: item.name,
      value: item.id,
      key: item.id,
    });
  });
  return options;
};

export const handleTransformData = (
  response: MultipleOriginsProductRawMaterial[]
) => {
  const data: transformedData = {
    ingredients: [],
    packageMaterials: [],
  };

  response.forEach(item => {
    if (item.type === TransportationProps.INGREDIENT) {
      if (!item?.subOrigin && item?.multipleOrigin?.length) {
        data.ingredients.push({
          id: item.multipleOrigin[0].id,
          ingredientName: item.activityLabel,
          bestFitProductionRegion: item?.multipleOrigin[0]
            ?.activityMappingRegionSpecId
            ? {
              label: item.multipleOrigin[0].userLocationLabel,
              value: item.multipleOrigin[0].activityMappingRegionSpecId,
            }
            : undefined,
          ingredientOrigin: item.multipleOrigin[0].origin,
          ingredientQuantity: item.quantity?.toString(),
          ingredientUnit: item.unit,
          address: item.multipleOrigin[0].address,
          origins: [],
        });
      } else {
        item?.multipleOrigin?.length &&
          data.ingredients.push({
            ingredientName: item.activityLabel,
            bestFitProductionRegion: undefined,
            ingredientOrigin: undefined,
            ingredientQuantity: item.quantity?.toString(),
            ingredientUnit: item.unit,
            origins: item.multipleOrigin?.map(origin => ({
              id: origin.id,
              ingredientOrigin: origin.origin,
              bestfitRegion: origin?.activityMappingRegionSpecId
                ? {
                  label: origin.userLocationLabel,
                  value: origin.activityMappingRegionSpecId,
                }
                : undefined,
              originShare: origin.originShare,
              percentage: '%',
              address: origin.address,
            })),
          });
      }
    } else if (item.type === TransportationProps.PACKAGING) {
      if (!item?.subOrigin && item?.multipleOrigin?.length) {
        data.packageMaterials.push({
          id: item.multipleOrigin[0].id,
          packingMaterialName: item.activityLabel,
          packingMaterialOrigin: item?.multipleOrigin[0].origin,
          packingMaterialQuantity: item?.quantity?.toString(),
          packingMaterialUnit: item.unit,
          packingMaterialbestFitProductionRegion: item?.multipleOrigin[0]
            .activityMappingRegionSpecId
            ? {
              label: item?.multipleOrigin[0].userLocationLabel,
              value: item?.multipleOrigin[0].activityMappingRegionSpecId,
            }
            : undefined,
          numberOfUnitsPerPackingMaterial: Number(
            item?.multipleOrigin[0].unitsPerPackagingMaterial
          ),
          address: item?.multipleOrigin[0].address,
          origins: [],
        });
      } else {
        item?.multipleOrigin?.length &&
          data.packageMaterials.push({
            packingMaterialName: item.activityLabel,
            packingMaterialOrigin: undefined,
            packingMaterialQuantity: item?.quantity?.toString(),
            packingMaterialUnit: item.unit,
            packingMaterialbestFitProductionRegion: undefined,
            numberOfUnitsPerPackingMaterial: Number(
              item?.multipleOrigin[0]?.unitsPerPackagingMaterial
            ),
            origins: item?.multipleOrigin?.map(origin => ({
              id: origin.id,
              ingredientOrigin: origin.origin,
              bestfitRegion: origin?.activityMappingRegionSpecId
                ? {
                  label: origin.userLocationLabel,
                  value: origin.activityMappingRegionSpecId,
                }
                : undefined,
              originShare: origin.originShare,
              percentage: '%',
              address: origin.address,
            })),
          });
      }
    }
  });

  return data;
};
